// Catalogues PDF officiels des fabricants, hébergés sur le site
export const CATALOGUES = [
  {
    id: 'slot-it-2025',
    brand: 'Slot.it',
    year: 2025,
    title: 'Accessoires & pièces détachées 2025',
    description:
      "Le catalogue officiel Slot.it : moteurs, châssis, pignons et couronnes, pneus, jantes, guides, pièces de carrosserie et poignées SCP. Toutes les références 1/32 avec leurs photos.",
    size: '10 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/5e62ccc04_catalogue-slot-it-accessoires-2025.pdf',
  },
  {
    id: 'policar-2025',
    brand: 'Policar',
    year: 2025,
    title: 'Voitures, pistes & accessoires 2025',
    description:
      "Le catalogue officiel Policar 2025 : gammes Formula 1, Classic Sport et Classic GT, système de piste complet, alimentations, bordures et pièces détachées.",
    size: '4,8 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/8abeca8ff_catalogue-policar-2025.pdf',
  },
  {
    id: 'policar-2022-accessoires',
    brand: 'Policar',
    year: 2022,
    title: 'Accessoires & pièces détachées 2022',
    description:
      "Le catalogue des accessoires Policar 2022 : pneus, jantes, guides, moteurs, châssis et pièces de rechange des modèles de la gamme.",
    size: '5,6 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/4b363ebb8_catalogue-policar-accessoires-2022.pdf',
  },
  {
    id: 'policar-2022-circuit',
    brand: 'Policar',
    year: 2022,
    title: 'Set de circuit & pistes 2022',
    description:
      "La présentation du système de piste Policar : rails, bordures, croisements, changeurs de voie et alimentations, avec les cotes de chaque élément.",
    size: '1,6 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/5541c0cc2_catalogue-policar-circuit-2022.pdf',
  },
  {
    id: 'policar-2021',
    brand: 'Policar',
    year: 2021,
    title: 'Voitures 2021',
    description:
      "Le catalogue des voitures Policar 2021 : monoplaces de Formule 1 et sport-prototypes classiques, avec les livrées et références de l'année.",
    size: '3,2 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/1d33a1ef8_catalogue-policar-voitures-2021.pdf',
  },
  {
    id: 'policar-2020',
    brand: 'Policar',
    year: 2020,
    title: 'Voitures 2020',
    description:
      "Le catalogue des voitures Policar 2020 : modèles disponibles cette année-là, livrées et références d'origine.",
    size: '3,8 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/b63c2369c_catalogue-policar-voitures-2020.pdf',
  },
  {
    id: 'policar-2020-circuit',
    brand: 'Policar',
    year: 2020,
    title: 'Brochure circuit 2020',
    description:
      "La brochure du circuit Policar : plan de piste, liste des éléments disponibles et conseils de montage pour composer un tracé complet.",
    size: '5,4 Mo',
    pdf_url:
      'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/46c1fa964_brochure-policar-circuit-2020.pdf',
  },
];

export default CATALOGUES;